import React, {useEffect, useState} from 'react';
import {
  Dimensions,
  Modal,
  StyleSheet,
  TouchableOpacity,
  Text,
  View,
  ScrollView,
} from 'react-native';
import Colors from '../../../assets/Color/Colors';
import {Network} from '../../../utils/network';
import BackgroundHeaderCard from '../childComponents/backgroundHeaderCard';
import ClubCreateFinal from '../childComponents/clubCreateFinal';
import CreateClubEvent from '../childComponents/createClubEvent';

const ClubCreationParent = ({navigation, route}) => {
  const [isConfirm, setIsConfirm] = useState(false);
  const [eventData, setEventData] = useState();
  const clubId = route.params?.clubId;

  useEffect(() => {}, []);

  const onConfirmationChangeScreen = data => {
    if (data?.title) {
      setEventData(data);
    }
    setIsConfirm(!isConfirm);
  };

  return (
    <ScrollView
      showsVerticalScrollIndicator={false}
      style={{flex: 1, backgroundColor: Colors.bgWhite}}
      contentContainerStyle={{flexGrow: 1}}>
      <BackgroundHeaderCard
        pageTitle={'Create an Event'}
        backButtonHandle={() => navigation.pop()}
        isEditIconShow={isConfirm}
        onConfirmationChangeScreen={onConfirmationChangeScreen}
      />
      <View style={{paddingHorizontal: 10, flex: 1}}>
        {isConfirm ? (
          <ClubCreateFinal
            clubEventDetails={eventData}
            clubId={clubId}
            navigation={navigation}
          />
        ) : (
          <CreateClubEvent
            onConfirmationChangeScreen={onConfirmationChangeScreen}
            eventData={eventData}
          />
        )}
      </View>
    </ScrollView>
  );
};

export default ClubCreationParent;
